import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import linkPage from '@editor/droplets/_bubble-options/components/link-page';
import Datepicker from 'vuejs-datepicker';
import { cardShape } from '@editor/droplets/utils';
import { eventDate } from '../../utils';

export default Vue.component('edit-cardsEvent', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['currentPage', 'currentSite', 'viewport']),
    minCount() {
      return this.droplet.cards.length < 2;
    },
    maxCount() {
      return this.droplet.cards.length >= this.cardLimit;
    },
    cards() {
      return this.droplet.cards;
    },
  },
  components: {
    Datepicker,
    linkPage,
  },
  data() {
    return {
      cardLoading: false,
      paginate: ['cards'],
      cardLimit: 6,
      editLinkForm: false,
      dateFormat: 'D dsu MMM yyyy',
      displayDate: new Date(),
      activeCard: null,
      highlightDate: {
        dates: [new Date()],
      },
    };
  },
  name: 'edit-cardsEvent',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    addCard() {
      const newCard = cardShape({
        type: 'droplet.cardsEvent.cardItem',
        event: eventDate(),
      })();
      const payload = {};
      payload.drp = this.droplet;
      payload.newCard = newCard;
      this.$store.dispatch('addNewEventCard', payload);
      this.$emit('css-generator');
    },
    removeCard(card, i) {
      const total = this.droplet.cards.length;
      if (total > 1) {
        this.$store.dispatch('spliceDropletVal', {
          array: this.droplet.cards,
          index: i,
        });
        this.$emit('css-generator');
        if (this.activeCard && card._id === this.activeCard._id) {
          this.resetFormValues();
        }
      }
    },
    bounceCard() {
      this.cardLoading = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          this.cardLoading = false;
          resolve();
        }, 250);
      });
    },
    async setFormValues(card) {
      this.activeCard = card;
      this.editLinkForm = true;
      this.displayDate = card.event.date;
      await this.bounceCard();
    },
    async resetFormValues() {
      this.activeCard = null;
      this.editLinkForm = false;
      this.displayDate = null;
      await this.bounceCard();
    },
    setDate(val) {
      const date = eventDate(val);
      this.$store.dispatch('setDropletVal', {
        drp: this.activeCard,
        key: 'event',
        val: date,
      });
    },
    closeDatePicker() {
      const picker = this.$refs.setPicker;
      if (!_.isUndefined(picker.clickOutside)) {
        picker.clickOutside(event);
      }
    },
    setBubbleSize(size) {
      this.$emit('set-bubble-size', size);
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    // our global _DropletOptions calls this on cancel if
    // we want any data options in this component reverted
    drzRevertData() {
      this.resetFormValues();
      this.$emit('css-generator');
    },
    drzClickSave() {
      this.resetFormValues();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/cards-event/components/_edit-options/index.js